import {DataItem} from "@swimlane/ngx-charts";
import {BatteryVoltage} from "src/app/domain/samples/rssi/battery-voltage";

export const maxRssi = (batteryVoltage: BatteryVoltage) => {
    const rssis = Object.values(batteryVoltage.rssiPerGateway);
    if (!rssis || rssis.length === 0) return;

    return rssis.reduce((a, b) => Math.max(a, b));
}

export const calculateSeries = (batteryVoltages: BatteryVoltage[]) => {
  const series: DataItem[] = [];

  batteryVoltages.forEach(batteryVoltage => {
    const rssi = maxRssi(batteryVoltage);
    if (rssi === undefined) return;

    series.push({
      name: batteryVoltage.instant,
      value: toPercentage(rssi)
    });
  });

  return [{
    name: "Signal strength",
    series
  }];
}


export function toPercentage(maxRssiRaw: undefined | number) {
  let maxRssiPercentage = 0;
  if (maxRssiRaw) {
    // maxRssiPercentage = Math.pow(10, (maxRssiRaw/10))
    maxRssiPercentage = 2 * (maxRssiRaw + 100)
  }
  if (maxRssiPercentage < 0) {
    maxRssiPercentage = 0
  }
  return maxRssiPercentage;
}
